/*
 * TODO: remove globals VidioHelpers and ahoy after all code move to gulp.
 *       use import or require
 */

export class RecommendedForYouTracker {
  constructor() {
    return true;
  }

  static get_tracking_properties(){
    var parentNode = $("#recommended-for-you, #recommended-for-you-parent");
    if(parentNode.length === 0) {
      return {};
    }
    var $widgets = parentNode.find(".video-widget, .video-widget-column");
    var recommender = $widgets.attr("data-recommender") || null;
    var is_fallback = $(".recommended-for-you-fallback").length > 0;

    return {
      recommendations: $widgets.map(function(){
        var $widget             = $(this);
        var recommendation_type = $widget.attr('data-item-type');
        return {
          video_id: $widget.data('videoId'),
          recommendation_type: recommendation_type
        };
      }).get(),
      recommender    : recommender,
      fallback       : is_fallback
    };
  }

  track() {
    var parentNode = $("#recommended-for-you, #recommended-for-you-parent");
    var props = RecommendedForYouTracker.get_tracking_properties();
    var properties = Object.assign(this.getCommonProperties(), props);
    if(parentNode.length === 0) {
      return {};
    }

    window.AhoyEvent.send('RECOMMENDATION::HOME::GET', properties);

    var that           = this;
    var videoSelectors = '[data-event="ctr_tracker"]';
    parentNode.on("click", videoSelectors, function() {
      that.trackClick(this);
    });

    $(".ga-mobile__recommended, #recommended-for-you-parent .title-recommended-for-you, #recommended-for-you-parent .video-grid__title-link").click(() => {
      this.trackSeeAll(properties.recommender);
    });
  }

  startTrackingFullPageClicks() {
    var parentNode     = $(".result#video-container, ul#latest-articles");
    var videoSelectors = '[data-event="ctr_tracker"]';

    var that           = this;
    parentNode.on("click", videoSelectors, function() {
      that.trackFullPageClick(this);
    });
  }

  trackClickWithName(name, node) {
    var identityParent = $(node).closest(".video-widget, .video-widget-column");

    var properties = this.getCommonProperties();
    Object.assign(properties, {
      video_id:            identityParent.data('videoId'),
      recommendation_type: identityParent.attr('data-item-type'),
      recommender:         identityParent.attr('data-recommender'),
      fallback:            identityParent.data('fallback') === 'yes'
    });
    window.AhoyEvent.send(name, properties);
  }

  trackClick(node) {
    this.trackClickWithName('RECOMMENDATION::HOME::CLICK', node);
  }

  trackSeeAll(recommender) {

    var properties = this.getCommonProperties();
    properties.recommender = recommender;

    if ($(".recommended-for-you-fallback").length > 0) {
      properties.fallback = true;
    }

    window.AhoyEvent.send('RECOMMENDATION::HOME::ALL', properties);
  }

  trackFullPageGet(fallbackCount, pageNumber, $videoWidgets) {
    var recommendations = $videoWidgets.map(function(){
      var $widget             = $(this);
      var recommendation_type = $widget.data('item-type');
      return {
        video_id: $widget.data('videoId'),
        recommendation_type: recommendation_type
      };
    }).get();

    var properties = this.getCommonProperties();
    Object.assign(properties, {
      recommendations: recommendations,
      fallback_count:  fallbackCount,
      total:           recommendations.length,
      page:            pageNumber,
      recommender:     'lateral',
      page_name:       'recommendation'
    });
    window.AhoyEvent.send('RECOMMENDATION::PAGE::GET', properties);
  }

  trackFullPageClick(node) {
    this.trackClickWithName('RECOMMENDATION::PAGE::CLICK', node);
  }

  addFallback($videoWidgets) {
    var hasFallback = $videoWidgets.filter('[data-item-type="popular"]').length > 0;

    $videoWidgets.attr('data-fallback', hasFallback ? 'yes' : 'no');
  }

  getCommonProperties(){
    return {
      embed: window.VidioHelpers.isEmbedVideo(),
      platform: window.VidioHelpers.getPlatform(),
      app_name: 'vidio',
      section: 'recommended_for_you',
      page_name: 'home'
    };
  }
}
